import { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { decryptURL, findOnArray } from 'utils/functions';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import InputMask from 'components/InputMask';
import Container from 'components/Container';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';

const Manutenção = () => {
  const rotina = 'QualidadeIndicadorResp';
  const defaultValues = {
    qualidade_indicador_id: null,
    sequencia: '',
    descricao: '',
    peso: '',
    minimo: '',
    maximo: '',
    inivalid: null,
    fimvalid: null,
  };
  const navigate = useNavigate();
  const { hash } = useParams();
  const decrypt = decryptURL(hash);
  const { drops } = useContext(DropsContext);
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset({ ...defaultValues, ...decrypt });
  }, []);

  const onSubmit = (data) =>
    postGrid({ data: { data, rotina }, cb: () => navigate(-1) });

  return (
    <Container>
      <Header
        titulo={`${Boolean(decrypt?.id) ? 'Editar' : 'Adicionar'} Resposta do Indicador de Qualidade`}
        subtitulo={findOnArray(
          decrypt?.qualidade_indicador_id,
          drops?.QualidadeIndicador,
          'label'
        )}
      />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Input
              name="sequencia"
              type="number"
              control={control}
              label="Sequência"
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <Input name="descricao" control={control} label="Descrição" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask name="peso" control={control} label="Peso" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask name="minimo" control={control} label="Mínimo" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask name="maximo" control={control} label="Máximo" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              type="date"
              name="inivalid"
              control={control}
              label="Data de Início"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              type="date"
              name="fimvalid"
              control={control}
              label="Data de Término"
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
